export default {
  lastname: {
    presence: { allowEmpty: false, message: "is required" }
  },
  firstname: {
    presence: { allowEmpty: false, message: "is required" }
  },
  emailaddress: {
    presence: { allowEmpty: false, message: "is required" },
    email: true
  },
  mobilenumber: {
    presence: { allowEmpty: false, message: "is required" },
    format: {
      pattern: /^(\+?1)?[2-9]\d{2}[2-9]\d{6}$/,
      message: "^Mobile number is not valid"
    }
  },
  confirmEmail: {
    presence: { allowEmpty: false, message: "is required" },
    email: true,
    equality: {
      attribute: "emailaddress",
      message: "^Email and confirm email does not match",
      comparator: (v1, v2) => {
        return v1 === v2;
      }
    }
  },
};
